module.exports = __webpack_public_path__ + "react.8FENTkZm.svg";